import { render, staticRenderFns } from "./su1SurveyParentComponent.vue?vue&type=template&id=00331fc6&scoped=true"
import script from "./su1SurveyParentComponent.vue?vue&type=script&lang=js"
export * from "./su1SurveyParentComponent.vue?vue&type=script&lang=js"
import style0 from "./su1SurveyParentComponent.vue?vue&type=style&index=0&id=00331fc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00331fc6",
  null
  
)

export default component.exports